import { isReferral } from "../../TransactionDetailsPage/shared/helpers";

const resolveTransactionType = (transactionType, buyerTransaction) => {
  if (isReferral(transactionType) || transactionType === "tenant" || transactionType === "landlord") {
    return transactionType;
  }
  return buyerTransaction ? "buyer" : "seller";
};

export default resolveTransactionType;
